
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Type_2_Diabetes_Control_Goals",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Type_2_Diabetes_Control_Goals.vue